// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d9e6d47b","952":"27c3c22c"}[chunkId] + ".chunk.js";
};